export default __webpack_public_path__ + "static/media/Bubble-Gun.9d53910d.png";